
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSlightlycloudyDayColour as ObiSlightlycloudyDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-slightlycloudy-day-colour.js';
 
 
 

 
 export const ObiSlightlycloudyDayColour = createComponent({
   react: React,
   tagName: 'obi-slightlycloudy-day-colour',
   elementClass: ObiSlightlycloudyDayColourElement,
   events: {
     
   }
  });
 
 